import type { PostMeta } from "../posts";

export const meta: PostMeta = {
  slug: "du-sol-renamed-cdoe-sports-scholarship",
  title:
    "DU Renames SOL to CDOE, Announces Arun Jaitley Sports Scholarship",
  description:
    "The School of Open Learning becomes the Campus of Distance and Online Education, and DU announces a sports scholarship in memory of Arun Jaitley. Here is what changes on the ground.",
  pubDate: "2026-07-25",
  updatedDate: "2026-07-26",
  authorSlug: "uday-kumar",
  category: "news",
  tags: ["SOL", "CDOE", "distance learning", "DU sports", "scholarship"],
  readMinutes: 5,
  heroEyebrow: "News · Policy",
};

export function Body() {
  return (
    <>
      <p>
        Delhi University's Academic Council approved two major structural decisions on July 25, 2026. First, the School of Open Learning (SOL)—which enrols the largest share of DU distance learners—is being renamed the Campus of Distance and Online Education (CDOE). Second, the university has instituted the Arun Jaitley Sports Scholarship for student athletes representing DU at national and international levels. Official notices will be posted on{" "}
        <a href="https://www.du.ac.in/" target="_blank" rel="noopener noreferrer">
          du.ac.in
        </a>{" "}
        and{" "}
        <a href="https://sol.du.ac.in/" target="_blank" rel="noopener noreferrer">
          sol.du.ac.in
        </a>
        .
      </p>

      <h2>Why SOL Becomes CDOE: UGC Regulations Alignment</h2>
      <p>
        The renaming brings DU into formal compliance with the{" "}
        <a
          href="https://www.ugc.gov.in/"
          target="_blank"
          rel="noopener noreferrer"
        >
          University Grants Commission (Open and Distance Learning Programmes and Online Programmes) Regulations 2020
        </a>
        . The UGC guidelines differentiate between legacy postal correspondence models and modern distance education integrating digital content, live interactive tutorials, and unified examination schedules.
      </p>
      <p>
        For enrolled SOL/CDOE students:
      </p>
      <ul>
        <li>Degrees previously awarded under the SOL title remain fully valid.</li>
        <li>Course codes, credit structures, and degree titles continue under the established framework.</li>
        <li>Students gain access to expanded online lecture libraries and digital learning portals hosted at{" "}
          <a href="https://sol.du.ac.in/" target="_blank" rel="noopener noreferrer">
            sol.du.ac.in
          </a>
          .
        </li>
      </ul>

      <h2>Arun Jaitley Sports Scholarship Details</h2>
      <p>
        Instituted in memory of former Union Minister and DU alumnus Arun Jaitley, this scholarship targets student-athletes who represent Delhi University at All India Inter-University championships, national games, or international sporting events.
      </p>
      <p>
        The scholarship program comprises an annual educational stipend alongside a coaching and equipment allowance. Selection guidelines and application forms will be published by the Delhi University Sports Council on{" "}
        <a href="https://www.du.ac.in/" target="_blank" rel="noopener noreferrer">
          du.ac.in
        </a>
        .
      </p>

      <div className="my-8 border border-grade bg-card p-5 text-sm">
        <strong className="mono-label text-grade">Primary Sources & Reference Links</strong>
        <p className="mt-2 text-pencil">
          Resolution data sourced from DU Academic Council proceedings and official portal releases at{" "}
          <a href="https://www.du.ac.in/" target="_blank" rel="noopener noreferrer">
            du.ac.in
          </a>{" "}
          and{" "}
          <a href="https://sol.du.ac.in/" target="_blank" rel="noopener noreferrer">
            sol.du.ac.in
          </a>
          . Regulatory context drawn from the{" "}
          <a href="https://www.ugc.gov.in/" target="_blank" rel="noopener noreferrer">
            UGC ODL Regulations 2020
          </a>
          . Secondary news reporting cross-referenced from{" "}
          <a
            href="https://dailypioneer.com/news/du-renames-sol-approves-direct-phd-for-4-year-ug-students"
            target="_blank"
            rel="noopener noreferrer"
          >
            The Daily Pioneer
          </a>{" "}
          and{" "}
          <a
            href="https://www.jagranjosh.com/news/delhi-university-ac-meeting-brings-direct-phd-path-new-skill-courses-and-sports-scholarship-185925"
            target="_blank"
            rel="noopener noreferrer"
          >
            Jagran Josh
          </a>
          .
        </p>
      </div>
    </>
  );
}

